<template>
  <!-- 企业账号与安全 - 1 -->
  <div class="module-Twe">
    <!-- 身份验证 -->
    <div class="verify">
      <div class="standing">
        <div class="standing-title">身份验证：</div>

        <div
          v-if="verifyData.auditStatus == '3'"
          class="standing-status already"
        >
          已验证
        </div>
        <div v-else class="standing-status">
          {{
            verifyData.auditStatus == "0"
              ? "未验证"
              : verifyData.auditStatus == "1"
              ? "审核中"
              : verifyData.auditStatus == "2"
              ? "未通过"
              : verifyData.auditStatus == "4"
              ? "需重新认证"
              : verifyData.auditStatus == "5"
              ? `已解绑${nextBindTime || "--"}后可再次绑定`
              : ""
          }}
        </div>
        <span class="firm-clickable"
          style="
            font-size: 14px;
            margin-left: 15px;
            color: #409eff ;
            text-decoration: underline;
          "
          v-if="verifyData.auditStatus == 2"
          @click="handelReason"
          >查看原因</span
        >
        <!-- <span
          style="font-size: 14px; margin-left: 15px; color: red"
          v-if="verifyData.auditStatus == 5"
          @click="handelReason"
          >{{ nextBindTime }}&nbsp;&nbsp;后可再次绑定</span
        > -->
      </div>
      <div
        class="Click-bind firm-clickable"
        v-if="verifyData.auditStatus == '0' || verifyData.auditStatus == '5'"
        @click="handelVerify(3, 0)"
      >
        <div>点击认证身份</div>
      </div>
      <div class="verified" v-else>
        <div class="name-p">姓名：{{ verifyData.legalPersonName }}</div>
        <div>身份证号：{{ verifyData.idNumber }}</div>
        <div class="firm-clickable" v-if="verifyData.auditStatus == '3'" @click="handelVerify(4)">
          解绑
        </div>
        <div v-if="verifyData.auditStatus == '3'" class="Look-out">
          （解绑后7天不可进行绑定）
        </div>
        <div class="firm-clickable"
          v-if="verifyData.auditStatus == '2' || verifyData.auditStatus == '4'"
          @click="handelVerify(3, 1)"
        >
          重新验证
        </div>
      </div>
      <div
        class="Click-bind firm-clickable"
        v-if="verifyData.auditStatus == '0' || verifyData.auditStatus == '5'"
        @click="handelReplaceMail"
      >
        <div>企业邮箱：{{ verifyData.mail }}点击更换</div>
      </div>
      <div class="verified" v-else>
        <div class="name-p"></div>
        <div>企业邮箱：{{ verifyData.mail }}</div>

        <div class="firm-clickable" @click="handelReplaceMail">更换</div>
      </div>
      <!-- 支付绑定 -->
      <!-- <div class="standing">
        <div class="standing-title">支付绑定：</div>
      </div>
      <div class="Payment-binding">
        <div class="bind-content">
          <div>
            <div class="bind-content-p" style="color: #666666">支付宝绑定：</div>
            <div class="bind-content-p" style="color: #333333">
              {{ verifyData.zfb || "待绑定" }}
            </div>
          </div>
          <el-button type="primary"
            class="button-p"
            v-if="verifyData.zfb == '' || verifyData.zfb == null"
            @click="handelBind(1)"
          >绑定</el-button>
          <el-button type="primary" class="button-p" v-if="verifyData.zfb" @click="handelUntie(1)">解绑</el-button>
          <el-button type="primary" class="button-p" v-if="verifyData.zfb" @click="handelSwitch(1)">更换</el-button>
        </div>
        <div class="bind-content">
          <div>
            <div class="bind-content-p" style="color: #666666">微信绑定：</div>
            <div class="bind-content-p" style="color: #333333">
              {{ verifyData.vx || "待绑定" }}
            </div>
          </div>
          <el-button type="primary"
            class="button-p"
            v-if="verifyData.vx == '' || verifyData.vx == null"
            @click="handelBind(2)"
          >绑定</el-button>
          <el-button type="primary" class="button-p" v-if="verifyData.vx" @click="handelUntie(2)">解绑</el-button>
          <el-button type="primary" class="button-p" v-if="verifyData.vx" @click="handelSwitch(2)">更换</el-button>
        </div>
        <div class="bind-content">
          <div>
            <div class="bind-content-p" style="color: #666666">银行卡绑定：</div>
            <div class="bind-content-p" style="color: #333333">
              {{ verifyData.BankCard || "待绑定" }}
            </div>
          </div>
          <el-button type="primary"
            class="button-p"
            v-if="verifyData.BankCard == '' || verifyData.BankCard == null"
            @click="handelBind(3)"
          >绑定</el-button>
          <el-button type="primary"
            class="button-p"
            v-if="verifyData.BankCard"
            @click="handelUntie(3)"
          >解绑</el-button>
          <el-button type="primary"
            class="button-p"
            v-if="verifyData.BankCard"
            @click="handelSwitch(3)"
          >更换</el-button>
        </div>
      </div> -->
      <!-- 支付密码 -->
      <div class="standing">
        <div class="standing-title">支付密码：</div>
        <div
          v-if="verifyData.payStatus != '-1'"
          :class="
            verifyData.payStatus == 0 ? 'Switch-box' : 'Switch-box-Select'
          "
          @click="handelPayment"
        ></div>
        <div v-if="verifyData.payStatus == 1" class="open">
          开启中，购买及充值需输入支付密码
        </div>
      </div>
      <div
        v-if="verifyData.payStatus == '-1'"
        class="Click-bind firm-clickable"
        @click="handelVerify(0)"
      >
        <div>点击开启支付密码</div>
      </div>
      <div v-else class="Click-cipher">
        <div class="cipher-btn" @click="handelVerify(1)">忘记密码</div>
        <div class="cipher-btn" @click="handelVerify(2)">更换密码</div>
      </div>
    </div>
    <TweWindow
      :dialogVerify="dialogVerify"
      :distinguish="distinguish"
      :PopUpTitle="PopUpTitle"
      :verifyData="verifyData"
      @handleCloseVerify="handleCloseVerify"
      @handleUnderstandVerify="handleUnderstandVerify"
    ></TweWindow>
    <TweUntie
      :dialogUntie="dialogUntie"
      :PopUpTitle="PopUpTitle"
      :untieOrOther="untieOrOther"
      @handleCancelUntie="handleCancelUntie"
      @handleVerifyUntie="handleVerifyUntie"
    ></TweUntie>
    <TweBank
      :dialogBank="dialogBank"
      :PopUpTitle="PopUpTitle"
      @handleCancelBank="handleCancelBank"
      @handleVerifyBank="handleVerifyBank"
    ></TweBank>
    <!-- 未通过原因 -->
    <ReasonWin
      :dialogReason="dialogReason"
      :Instruction="verifyData.auditText"
      :title="'未通过原因'"
      @handleCloseReason="dialogReason = false"
    ></ReasonWin>
    <!-- 更换企业邮箱 -->
    <EnterpriseEmail
      :dialogVisible="dialogVisible"
      :AccountInformation="verifyData.mail"
      @handleClose="dialogVisible = false"
      @handleUnderstand="handleUnderstand"
    ></EnterpriseEmail>
  </div>
</template>

<script>
// 引入接口
import {
  getIdentityAudit, //获取法人信息认证
  switchCompanyPayStatus, //切换支付密码状态
} from "../../../../../assets/api/firm/firmCenter";
import TweWindow from "./TweWindow.vue";
import TweUntie from "./TweUntie.vue"; //支付绑定 解绑弹窗
import TweBank from "./TweBank.vue"; //绑定更换银行卡
import ReasonWin from "./ReasonWin.vue"; //未通过原因
import EnterpriseEmail from "./EnterpriseEmail.vue"; //更换企业邮箱
export default {
  data() {
    return {
      verifyData: {
        auditStatus: "5", //0未验证  1审核中 2未通过 3已验证  4需重新认证
        payStatus: "-1", //支付密码 1开启 0未开启
        zfb: "11",
        vx: "",
        BankCard: "1",
      }, // 身份是否验证，支付密码是否开启
      dialogVerify: false, //身份验证页面弹窗
      distinguish: "1", // 1.开启支付密码 2.忘记/更换密码 3.点击认证身份 4.解绑
      PopUpTitle: "", //弹窗标题
      PaymentBinding: "", //支付绑定 1处理支付宝的绑定解绑更换  2处理微信  3处理银行卡  处理事件是该参数代表是微信支付宝还是银行卡
      dialogUntie: false, // 解绑 弹窗
      untieOrOther: "", // 解绑/其他 ''解绑 1绑定 2更换
      dialogBank: false, //绑定 更换银行卡
      dialogReason: false, //未通过原因
      nextBindTime: "", //计算什么时候可以重新绑定
      nextBindTimeNew: "", //
      CurrentlyTime: "", //
      dialogVisible: false, //更换企业邮箱弹窗
    };
  },
  watch: {},
  components: { TweWindow, TweUntie, TweBank, ReasonWin, EnterpriseEmail },
  created() {
    // 未登录预览不打接口
    const user = this.$store.getters.getUser;
    if (!(user && user.id)) return;
    // 获取法人信息认证
    this.getIdentityAudit();
  },
  methods: {
    // 点击更换邮箱
    handelReplaceMail() {
      if (!this.$checkAction()) return;
      this.dialogVisible = true;
    },
    // 更换邮箱确认
    handleUnderstand() {
      this.getIdentityAudit();
      this.dialogVisible = false;
    },
    // 查看未通过原因
    handelReason() {
      this.dialogReason = true;
    },
    // 获取法人信息认证
    getIdentityAudit() {
      var data = {
        data: {
          companyId: this.$store.getters.getCompany.id,
        },
      };
      getIdentityAudit(data).then((res) => {
        if (res.code == 0) {
          // this.verifyData.auditStatus = res.data.auditStatus;
          // this.verifyData.payStatus = res.data.payStatus;
          this.verifyData = res.data;
          if (
            this.verifyData.nextBindTime &&
            this.verifyData.nextBindTime != ""
          ) {
            this.nextBindTime = this.verifyData.nextBindTime;
            const newDate = new Date(this.verifyData.nextBindTime);
            this.nextBindTimeNew = newDate.setDate(newDate.getDate()); // 直接在原对象上修改，不接收返回值
            this.CurrentlyTime = new Date().getTime();
            // console.log(this.nextBindTimeNew, "this.nextBindTime" , );
          }
        }
      });
    },
    // 日期格式化：yyyy-MM-dd HH:mm:ss
    formatDate(date) {
      // 增加类型校验，防止非 Date 对象传入
      if (!(date instanceof Date) || isNaN(date.getTime())) {
        console.error("formatDate 传入的不是有效日期对象:", date);
        return ""; // 或返回默认值
      }
      const y = date.getFullYear();
      const m = (date.getMonth() + 1).toString().padStart(2, "0");
      const d = date.getDate().toString().padStart(2, "0");
      const hh = date.getHours().toString().padStart(2, "0");
      const mm = date.getMinutes().toString().padStart(2, "0");
      const ss = date.getSeconds().toString().padStart(2, "0");
      return `${y}-${m}-${d} ${hh}:${mm}:${ss}`;
    },
    //支付绑定 - 绑定
    handelBind(num) {
      if (!this.$checkAction()) return;
      // num 1支付宝绑定  2微信绑定   3银行卡绑定
      this.PaymentBinding = num;
      this.untieOrOther = "1";
      if (num == 1 || num == 2) {
        this.PopUpTitle = "绑定支付宝/微信";
        this.dialogUntie = true;
      } else {
        this.PopUpTitle = "绑定银行卡";
        this.dialogBank = true;
      }
    },
    //支付绑定 - 解绑
    handelUntie(num) {
      if (!this.$checkAction()) return;
      // num 1支付宝解绑  2微信解绑   3银行卡解绑
      this.PaymentBinding = num;
      this.untieOrOther = "";
      this.PopUpTitle = "解绑";
      this.dialogUntie = true;
    },
    //支付绑定 - 更换
    handelSwitch(num) {
      if (!this.$checkAction()) return;
      // num 1支付宝更换 2微信更换   3银行卡更换
      this.PaymentBinding = num;
      this.untieOrOther = "2";
      if (num == 1 || num == 2) {
        this.PopUpTitle = "更换支付宝/微信";
        this.dialogUntie = true;
      } else {
        this.PopUpTitle = "更换银行卡";
        this.dialogBank = true;
      }
    },
    // 支付绑定 - 全部解绑  微信支付宝更换绑定 弹窗取消
    handleCancelUntie() {
      this.dialogUntie = !this.dialogUntie;
    },
    // 支付绑定 - 全部解绑  微信支付宝更换绑定 弹窗确认
    handleVerifyUntie() {
      this.dialogUntie = !this.dialogUntie;
    },

    // 银行卡绑定/更换  弹窗取消
    handleCancelBank() {
      this.dialogBank = !this.dialogBank;
    },
    // 银行卡绑定/更换  弹窗确认
    handleVerifyBank() {
      this.dialogBank = !this.dialogBank;
    },

    // 支付密码 滑块
    handelPayment() {
      if (!this.$checkAction()) return;
      this.distinguish = "5";
      this.PopUpTitle = "支付密码状态切换";
      this.dialogVerify = true;
      //this.verifyData.payStatus = !this.verifyData.payStatus;
    },
    // 身份验证页面弹窗
    handelVerify(num, num1) {
      if (!this.$checkAction()) return;
      if (num == 0) {
        this.distinguish = "0";
        this.PopUpTitle = "开启支付密码";
        this.dialogVerify = true;
      } else if (num == 1) {
        this.distinguish = "1";
        this.PopUpTitle = "忘记密码";
        this.dialogVerify = true;
      } else if (num == 2) {
        this.distinguish = "1";
        this.PopUpTitle = "更换密码";
        this.dialogVerify = true;
      } else if (num == 3) {
        if (num1 == 0 && this.nextBindTime != "" && this.nextBindTime != null) {
          if (this.CurrentlyTime > this.nextBindTimeNew) {
            this.dialogVerify = true;
          } else {
            this.$tool.PromptBox(
              "warning",
              `请在${this.nextBindTime}以后进行身份认证`
            );
          }
        } else {
          this.dialogVerify = true;
        }
        this.distinguish = "3";
        this.PopUpTitle = "认证身份";
      } else if (num == 4) {
        this.distinguish = "4";
        this.PopUpTitle = "解绑";
        this.dialogVerify = true;
      }
    },
    // 身份验证弹窗 关闭
    handleCloseVerify(val) {
      this.dialogVerify = !this.dialogVerify;
    },
    //身份验证弹窗 确认
    handleUnderstandVerify(val, data) {
      // if (val == "3") {
      // 刷新法人身份数据接口
      if (val == "5") {
        data.data.payStatus = this.verifyData.payStatus == "0" ? "1" : "0";
        switchCompanyPayStatus(data).then((res) => {
          if (res.code == 0) {
            this.$tool.PromptBox("success", "操作成功");
            this.getIdentityAudit();
          } else {
            // this.$tool.PromptBox("error", res.msg);
          }
        });
      } else {
        this.getIdentityAudit();
      }
      // }
      this.dialogVerify = !this.dialogVerify;
    },
  },
};
</script>

<style scoped lang="less">
// 模块1 最外层
.module-Twe {
  width: 100%;
  min-height: 50px;
}
// 身份验证
.verify {
  width: 100%;
  min-height: 30px;
  margin-top: 20px;
  .standing {
    width: 100%;
    height: 30px;
    line-height: 30px;
    display: flex;
    .standing-title {
      font-family: PingFangSC-Medium;
      font-size: 20px;
      color: #333333;
      font-weight: 400;
    }
    .standing-status {
      min-width: 50px;
      height: 30px;
      padding: 0px 5px;
      background: #eeeeee;
      border: 1px solid #999999;
      border-radius: 5px;
      font-size: 12px;
      color: #333333;
      text-align: center;
      font-weight: 400;
      margin-left: 15px;
    }
    .already {
      background: #ffffff;
      border: 1px solid #95ec6a;
    }
    .open {
      font-family: PingFangSC-Medium;
      font-size: 14px;
      line-height: 35px;
      color: #333333;
      font-weight: 400;
      margin-left: 40px;
    }
    .Switch-box {
      width: 60px;
      height: 30px;
      margin-left: 15px;
      border-radius: 10px;
      background-image: url("../../../../../assets/imgs/weikaiqi@3x.svg");
      background-size: 100% 100%;
      cursor: pointer;
    }
    .Switch-box-Select {
      width: 60px;
      height: 30px;
      margin-left: 15px;
      border-radius: 10px;
      background-image: url("../../../../../assets/imgs/kaiqi@3x.svg");
      background-size: 100% 100%;
      cursor: pointer;
    }
  }
  // 已验证
  .verified {
    width: 100%;
    height: 20px;
    line-height: 20px;
    margin-bottom: 50px;
    margin-top: 30px;
    display: flex;
    align-items: center;
    > div {
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #333333;
      font-weight: 400;
      margin-right: 50px;
    }
    .name-p {
      min-width: 100px;
    }
    .Look-out {
      font-size: 12px;
      color: #666666;
      font-weight: 400;
      margin-right: 0;
    }
    .firm-clickable {
      min-width: 45px;
      height: 20px;
      line-height: 20px;
      padding: 0 5px;
      background: #409eff;
      border-radius: 5px;
      font-size: 12px;
      color: #ffffff;
      text-align: center;
      font-weight: 400;
      cursor: pointer;
      margin-right: 50px;
    }
  }
  //已开启支付密码
  .Click-cipher {
    width: 100%;
    height: 30px;
    line-height: 30px;
    display: flex;
    margin-bottom: 50px;
    margin-top: 30px;
    .cipher-btn {
      width: 85px;
      height: 30px;
      background: #409eff ;
      border-radius: 5px;
      font-size: 12px;
      color: #ffffff;
      text-align: center;
      font-weight: 400;
      margin-right: 30px;
      cursor: pointer;
    }
  }
  // 支付绑定内容
  .Payment-binding {
    width: 100%;
    min-height: 50px;
    margin-top: 30px;
    margin-bottom: 50px;
    .bind-content {
      width: 100%;
      height: 20px;
      line-height: 20px;
      margin-top: 22px;
      display: flex;
      div {
        min-width: 450px;
        height: 100%;
        display: flex;
      }
      .bind-content-p {
        font-family: PingFangSC-Medium;
        font-size: 16px;
        font-weight: 400;
      }
      .button-p {
        width: 45px;
        height: 20px;
        background: #409eff ;
        border-radius: 5px;
        margin-right: 20px;
        font-family: PingFangSC-Medium;
        font-size: 12px;
        color: #ffffff;
        text-align: center;
        font-weight: 400;
      }
    }
    .bind-content:nth-child(1) {
      margin-top: 0px;
    }
  }
  // 未绑定/未开启支付密码
  .Click-bind {
    width: 100%;
    height: 50px;
    line-height: 50px;
    border: 1px dashed #409eff ;
    margin-bottom: 50px;
    margin-top: 30px;
    display: flex;
    border-radius: 5px;
    font-size: 12px;
    color: #333333;
    font-weight: 400;
    div {
      width: 100%;
      text-align: center;
      cursor: pointer;
    }
  }
}
</style>
